<!--
 * @Author: chenlei
 * @Date: 2020-11-24 17:42:03
 * @LastEditors: chenlei
 * @LastEditTime: 2020-11-26 21:37:24
 * @Description:
-->
<script>
import Form, { formCreate } from '../../../../../components/form';
import DictTable from './table';

formCreate.component('DictTable', DictTable);

export default {
  extends: Form,
  components: {
    DictTable,
    formCreate: formCreate.$form(),
  },
  data() {
    return {
      buttons: {
        submit: false,
        close: true,
      },
      rule: [
        {
          type: 'DictTable',
          field: 'list',
          props: {
            code: '',
          },
        },
      ],
    };
  },
  mounted() {
    this.updateRules({
      list: {
        props: {
          code: this.formConfig.selectRow ? this.formConfig.selectRow.dictTypeCode : '',
        },
      },
    });
  },
  methods: {
    submit() {},
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-pagination {
  margin-top: 20px;
  .el-pagination__editor {
    display: inline-block !important;
  }
}

.dialog-footer {
  position: absolute;
  bottom: 0;
  right: 0;
}
</style>
